import { useLingui } from "@lingui/react";
import { formatPrice } from "@mobility-item-page/utilities";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import { isFinn } from "src/utils/brand.ts";
import FieldValuePair from "../FieldValuePair.tsx";

type Props = {
  registration_tax_url?: string;
  registration_price?: number;
  main?: number;
  registration_tax_exemption?: boolean;
};

export const RegistrationTax = ({
  registration_price,
  registration_tax_url,
  main,
  registration_tax_exemption,
}: Props) => {
  const { brand } = useAppConfig();
  if (!isFinn(brand)) {
    return null;
  }

  const showPrice = !registration_tax_exemption && !!registration_price;

  return (
    <>
      <ReRegistrationPrice
        registration_price={registration_price}
        registration_tax_url={registration_tax_url}
        registration_tax_exemption={registration_tax_exemption}
      />
      {showPrice && <RegistrationPrice main={main} />}
    </>
  );
};

const ReRegistrationPrice = ({
  registration_price,
  registration_tax_url,
  registration_tax_exemption,
}: {
  registration_price: number | undefined;
  registration_tax_url?: string;
  registration_tax_exemption: boolean | undefined;
}) => {
  const { i18n } = useLingui();
  const { brand, locale } = useAppConfig();
  const field = i18n._({
    id: "itemPageLayout.keyInfo.registrationTax.reRegistration",
    message: "Re-registration",
    comment: "Field for 're-registration' price in ad specification",
  });

  const link = registration_tax_url
    ? {
        href: registration_tax_url,
        text: i18n._({
          id: "itemPageLayout.keyInfo.registrationTax.reRegistrationLinkText",
          message: "taxes",
          comment: "Link to tax information after the re-registration field in ad specification",
        }),
      }
    : undefined;
  const formatedRegistrationPrice = () => {
    if (registration_tax_exemption) {
      return i18n._({
        id: "itemPageLayout.keyInfo.registrationTax.exempted",
        message: "Exempted",
        comment: "When registration tax price is exempted",
      });
    } else if (registration_price === undefined || registration_price === 0) {
      return i18n._({
        id: "itemPageLayout.keyInfo.registrationTax.noPrice",
        message: "Not specified",
        comment: "When registration tax price is not specified",
      });
    } else {
      return formatPrice(registration_price, locale, brand);
    }
  };
  const value = formatedRegistrationPrice();
  return <FieldValuePair field={field} value={value} link={link} />;
};

const RegistrationPrice = ({ main }: { main: number | undefined }) => {
  const { i18n } = useLingui();
  const { brand, locale } = useAppConfig();

  if (main == null) {
    return null;
  }

  const mainPriceText = i18n._({
    id: "itemPageLayout.keyInfo.registrationTax.priceWithoutTax",
    message: "Price excl. tax",
    comment: "Field for 'Price excl. tax' (main price) in ad specification",
  });
  const value = formatPrice(main, locale, brand);

  return <FieldValuePair field={mainPriceText} value={value} />;
};
